export default {
  NONE: 'NONE',
  TEXT: 'TEXT',
  OPTIONS: 'OPTIONS',
  DATE_PICKER: 'DATE_PICKER',
  SALARY_PICKER: 'SALARY_PICKER',
  FILE_UPLOAD: 'FILE_UPLOAD',
  TAG_LIST: 'TAG_LIST',
  USER_TYPE: 'USER_TYPE',
  JOB_TYPE: 'JOB_TYPE',
  MULTIPLE_SELECT_OPTIONS: 'MULTIPLE_SELECT_OPTIONS',
  DATA_SEARCH: 'DATA_SEARCH',
  GEOLOCATION: 'GEOLOCATION',
  GENDER: 'CANDIDATE_GENDER',
};
